// [PROSPEK] 2026-06-05 Pure module for attribute-model gating
// Extracted from AddAttribute.vue to enable real-logic testing (no replica).
// id 0 = conversation model; when flagged, it must be excluded from creatable models.

/**
 * Filter ATTRIBUTE_MODELS based on whether conversation attributes are disabled.
 * @param {Array} models - The full ATTRIBUTE_MODELS list from constants.js
 * @param {boolean} isConversationDisabled - Result of the feature-flag check
 * @returns {Array} Filtered models (conversation excluded when flag is ON)
 */
export const filterCreatableAttributeModels = (
  models,
  isConversationDisabled
) => (isConversationDisabled ? models.filter(m => m.id !== 0) : models);
